import Modal from "~app/Modal"
import TableSearchField from "~components/TableSearchField"
import PerksList from "~components/perks/PerksList"
import { ACTIONS } from "~pages/private/perks"
import { TableTopGroup } from "~styled/table"
import { PerkShape } from "~shapes/perk"

interface Props {
  isOpened: boolean
  isLoading: boolean
  perks: any
  onRequestClose: () => void
  onRequestConfirm: () => void
  search: any
  onSelectPerk: (perk: PerkShape) => void
}

const PerksModal = ({
  isOpened,
  onRequestClose,
  onRequestConfirm,
  perks,
  isLoading,
  search,
  onSelectPerk,
}: Props) => {
  const handleSelectPerk = (perk: PerkShape) => {
    onSelectPerk(perk)
  }

  return (
    <Modal
      isOpen={isOpened}
      buttonLabel={""}
      onRequestClose={onRequestClose}
      onRequestConfirm={onRequestConfirm}
      scrollable={true}
      maxWidth={"1300px"}
    >
      <TableTopGroup>
        <TableSearchField
          searchBy={["company.name"]}
          placeholder="SEARCH BY COMPANY NAME"
          callback={search}
        />
      </TableTopGroup>
      <PerksList
        onClickRedeemButton={handleSelectPerk}
        perks={perks}
        isLoading={isLoading}
        action={ACTIONS.REDEEM}
      />
    </Modal>
  )
}
export default PerksModal
